var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"eventRaceImages",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"pa-3"},[_c('RaceAdvanceSetting')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }